<template>
  <v-container>
    <v-layout row wrap
              fill-height>
      <v-flex class="xs12 pa-0">
        <h2 class="nx-block-headline">{{ $t('message.milenium.createContent') }}</h2>
      </v-flex>
      <v-flex class="fill-height xs12">
        <v-progress-linear v-if="loading" indeterminate color="accent" height="4"></v-progress-linear>
        <nx-milenium-form-generator
          v-if="!loading && formConfig"
          :config="formConfig"
          :fields-lines="fieldsLines"
          :value="value"
          :master-channel-values="masterChannelValues"
          @form="$emit('form', $event)"
          @input="updateDraft"
          @linkField="handleLinkField"
        ></nx-milenium-form-generator>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import api from '@/modules/milenium/api';
import NxMileniumFormGenerator from '@/modules/milenium/components/form/MileniumFormGenerator';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    NxMileniumFormGenerator,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    contentId: {
      type: Number,
      required: true,
    },
    publicationId: {
      type: Number,
      required: true,
    },
    publicationTypeId: {
      type: Number,
      required: true,
    },
    positionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      fieldsConfig: null,
      fieldsLines: {},
      masterChannelValues: {},
    };
  },
  computed: {
    formConfig() {
      if (!this.fieldsConfig) return null;
      return {
        fieldsConfig: this.fieldsConfig,
      };
    },
  },
  methods: {
    reset() {
      this.fieldsConfig = null;
      this.$emit('input', {});
    },
    updateDraft(field, value) {
      this.$emit('input', { ...this.value, ...{ [field]: value } });
    },
    handleLinkField({ field, linkingField }) {
      const linkingValue = linkingField in this.masterChannelValues
        ? this.masterChannelValues[linkingField]
        : this.value[field].value;
      const fieldValue = {
        ...this.value[field],
        ...{ value: cloneDeep(linkingValue), linkingField },
      };
      this.$emit('input', { ...this.value, ...{ [field]: fieldValue } });
    },
    async loadWizardEditor() {
      if (!this.contentId || !this.publicationId || !this.publicationTypeId || !this.positionId) return;
      this.loading = true;
      try {
        const {
          fields,
          fieldsConfig,
          fieldsLines,
          masterChannelValues,
        } = await api.getContentPagePositionWizard(
          this.contentId,
          this.publicationTypeId,
          this.publicationId,
          this.positionId,
        );
        this.fieldsConfig = fieldsConfig;
        this.fieldsLines = fieldsLines;
        this.masterChannelValues = masterChannelValues;

        // Initialize to null empty values
        this.fieldsConfig.forEach((config) => {
          if (!(config.field in fields)) {
            fields[config.field] = {
              value: null,
            };
          }
        });

        this.$emit('input', fields);
      } catch (error) {
        console.error('Error loading page positions', error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    positionId: {
      async handler() {
        this.reset();
        await this.loadWizardEditor();
      },
      immediate: true,
    },
  },
};
</script>
